// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lf-3";
export var downloadButton = "_lf-4";
export var fileContainer = "_lf-9 _lf-7";
export var fileContainerBase = "_lf-7";
export var fileContainerFixedHeight = "_lf-8 _lf-7";
export var fileInfo = "_lf-5";
export var fileInfoWidthRestricted = "_lf-6";
export var fileType = "_lf-1";
export var fileTypeName = "_lf-2";
export var image = "_lf-0";
export var link = "_lf-b";
export var overflowEllipsis = "_lf-a";